import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "sonner";
import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import { WhatsAppButton } from "@/components/WhatsAppButton";
import { AdminGuard } from "@/components/AdminShell";
import Home from "@/pages/Home";
import Tentang from "@/pages/Tentang";
import Layanan from "@/pages/Layanan";
import Tim from "@/pages/Tim";
import Artikel from "@/pages/Artikel";
import ArtikelDetail from "@/pages/ArtikelDetail";
import Kontak from "@/pages/Kontak";
import Galeri from "@/pages/Galeri";
import BeritaHukum from "@/pages/BeritaHukum";
import Kasus from "@/pages/Kasus";
import KasusDetail from "@/pages/KasusDetail";
import AdminLogin from "@/pages/admin/AdminLogin";
import AdminKonsultasi from "@/pages/admin/AdminKonsultasi";
import AdminArtikel from "@/pages/admin/AdminArtikel";
import AdminTim from "@/pages/admin/AdminTim";
import AdminGaleri from "@/pages/admin/AdminGaleri";
import AdminBerita from "@/pages/admin/AdminBerita";
import AdminKasus from "@/pages/admin/AdminKasus";
import AdminPengumuman from "@/pages/admin/AdminPengumuman";

const ScrollManager = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "instant" });
  }, [pathname]);
  return null;
};

const Chrome = () => {
  const { pathname } = useLocation();
  const isAdmin = pathname.startsWith("/admin");
  return (
    <>
      {!isAdmin && <Navbar />}
      <main>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/tentang" element={<Tentang />} />
          <Route path="/layanan" element={<Layanan />} />
          <Route path="/tim" element={<Tim />} />
          <Route path="/artikel" element={<Artikel />} />
          <Route path="/artikel/:slug" element={<ArtikelDetail />} />
          <Route path="/kontak" element={<Kontak />} />
          <Route path="/galeri" element={<Galeri />} />
          <Route path="/berita" element={<BeritaHukum />} />
          <Route path="/kasus" element={<Kasus />} />
          <Route path="/kasus/:slug" element={<KasusDetail />} />
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin" element={<AdminGuard><AdminKonsultasi /></AdminGuard>} />
          <Route path="/admin/artikel" element={<AdminGuard><AdminArtikel /></AdminGuard>} />
          <Route path="/admin/tim" element={<AdminGuard><AdminTim /></AdminGuard>} />
          <Route path="/admin/galeri" element={<AdminGuard><AdminGaleri /></AdminGuard>} />
          <Route path="/admin/berita" element={<AdminGuard><AdminBerita /></AdminGuard>} />
          <Route path="/admin/kasus" element={<AdminGuard><AdminKasus /></AdminGuard>} />
          <Route path="/admin/pengumuman" element={<AdminGuard><AdminPengumuman /></AdminGuard>} />
          <Route path="*" element={<Home />} />
        </Routes>
      </main>
      {!isAdmin && <Footer />}
      {!isAdmin && <WhatsAppButton />}
    </>
  );
};

function App() {
  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09, smoothWheel: true });
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
    };
  }, []);

  return (
    <div className="min-h-screen bg-ink text-foreground antialiased">
      <BrowserRouter>
        <ScrollManager />
        <div className="grain-overlay" aria-hidden="true" />
        <Chrome />
        <Toaster
          theme="dark"
          position="top-center"
          toastOptions={{
            style: {
              background: "#121212",
              border: "1px solid rgba(197,160,89,0.4)",
              color: "#F5F5F5",
            },
          }}
        />
      </BrowserRouter>
    </div>
  );
}

export default App;
